import useSeo from "@/hooks/useSeo";
import HeroCarousel from "./components/HeroCarousel";
import TodaySchedule from "./components/TodaySchedule";
import QuickNav from "./components/QuickNav";
import NewsSidebar from "./components/NewsSidebar";

export default function Home() {
  useSeo({
    title: "NBA直播吧 - 实时NBA篮球比赛直播平台",
    description:
      "NBA直播吧提供最新的NBA比赛直播和赛程信息，涵盖全面的赛事动态，让篮球迷随时掌握比赛实况。",
    keywords: "NBA直播吧,NBA直播,NBA比赛直播,篮球直播,NBA赛程,NBA视频,NBA实况",
  });

  return (
    <div>
      <HeroCarousel />

      <section className="w-full px-4 md:px-6 py-8 md:py-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 flex flex-col gap-6">
            <TodaySchedule />
            <QuickNav />
          </div>
          <div className="lg:col-span-1">
            <NewsSidebar />
          </div>
        </div>
      </section>
    </div>
  );
}